/**
 * Presets de barre d'outils TipTap (formulaires BO / Notes / PDF).
 *
 * - published : champs RichText rendus sur le site public
 * - complete  : notes internes + outil Notes + exports PDF/Word + MediaLibrary
 * - compact   : autres champs BO non publiés
 */

export type ToolbarPreset = "published" | "complete" | "compact";

/** Champs (ou fragments de nom) affichés sur le site public. */
const PUBLISHED_FIELD_RE =
  /(?:Remarques|Notes)Publiques|Resume|ResumeCourt|DescriptionComplete|LegendeRedigee|SocleDescription|SculptureDescriptionEditions|PresentationSculpture|SculptureNotesGenerales|TirageKnownDescription|TirageMasterDescription|InscriptionsDos|content\b/i;

/**
 * Notes internes / régie / travail — barre complète BO (sans H2/H3/Lire plus).
 * Évalué après `published` pour ne pas capturer NotesPubliques.
 */
const COMPLETE_FIELD_RE =
  /Notes(?!Publiques)|RemarquesPersonnelles|additionalParagraph|coverPage|notes\./i;

/**
 * Déduit le preset depuis le nom de champ React Hook Form.
 * Les call sites Notes / PDF / MediaLibrary forcent `complete` via prop.
 */
export function resolveToolbarPreset(fieldName?: string): ToolbarPreset {
  if (!fieldName) return "compact";
  if (PUBLISHED_FIELD_RE.test(fieldName)) return "published";
  if (COMPLETE_FIELD_RE.test(fieldName)) return "complete";
  return "compact";
}

export function presetShowsReadMore(preset: ToolbarPreset): boolean {
  return preset === "published";
}

export function presetShowsHeadings(preset: ToolbarPreset): boolean {
  return preset === "published";
}

export function presetShowsFontFamily(preset: ToolbarPreset): boolean {
  return preset === "published" || preset === "complete";
}

export function presetShowsSpacing(preset: ToolbarPreset): boolean {
  return preset === "published" || preset === "complete";
}

export function presetShowsBulletList(preset: ToolbarPreset): boolean {
  return preset === "published" || preset === "complete";
}

export function presetShowsSeparator(preset: ToolbarPreset): boolean {
  return preset === "published" || preset === "complete";
}
